import { start } from "./core.js";
export { start };

if (typeof window !== "undefined") {
  window.HyperInstantStart = () => start(window.HyperInstant);
  start(window.HyperInstant);
}
